import React, { useState } from "react";

/**
 * Contact avatar — renders profile photo if URL provided, otherwise the initial letter.
 * Gracefully falls back to initial if the image fails to load.
 *
 * Props:
 *   src   – photo URL (nullable)
 *   name  – used for initial + alt
 *   size  – px (default 40)
 *   className – additional classes for the outer wrapper
 */
export default function ContactAvatar({ src, name, size = 40, className = "" }) {
  const [broken, setBroken] = useState(false);
  const initial = String(name || "?").trim().charAt(0).toUpperCase() || "?";
  const style = { width: size, height: size, fontSize: Math.max(10, Math.floor(size * 0.4)) };

  if (src && !broken) {
    return (
      <img
        src={src}
        alt={name || ""}
        onError={() => setBroken(true)}
        className={`rounded-full object-cover flex-none border border-border ${className}`}
        style={style}
        data-testid="contact-avatar-img"
        loading="lazy"
      />
    );
  }
  return (
    <div
      className={`rounded-full bg-primary/20 text-white font-bold flex items-center justify-center flex-none ${className}`}
      style={style}
      data-testid="contact-avatar-initial"
      aria-label={name || ""}
    >
      {initial}
    </div>
  );
}
